module.exports = fox._r("images/chat-gifts/gift-34.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/chat-gifts/gift-34.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/chat-gifts/gift-34.png
// module id = 235
// module chunks = 4